import React from 'react';
import { Modal, Input, Form, Select, message } from 'antd';
import { FORMAT_EMAIL } from '../../../common/types/regularExpresionType';
class CorreoModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleCancel = () => {
        this.props.form.resetFields();
        this.props.onClose();
    }

    correoCustomValidation = (rule, value, callback) => {
        
        var regexp = new RegExp(FORMAT_EMAIL);
        if (value !== undefined && value !== "" && !regexp.test(value))
            callback('Formato de correo invalido.');
            
        callback();
    }

    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
               
            if  (values.correoCliente ==="" || values.correoCliente == undefined) 
            {
                message.warning("Ingrese un correo válido");
                return;
            }

            console.log(values);
            if (!err) {
                const form = {
                    idComprobante: values.idComprobante,
                    correoCliente: values.correoCliente,
                    copia: values.copia,
                    idFormato: this.props.formValues.idFormato,
                }
                
                this.props.onSend(form, this.props.form);
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        getFieldDecorator('idComprobante', { initialValue: this.props.formValues.idComprobante });
        return (
            <Modal
                title={"Enviar Correo"}
                visible={this.props.visible}
                cancelText={"Cancelar"}
                okText={"Enviar Correo"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                destroyOnClose={true}
                style={{ top: 30 }}
                width={800}
            >
                <Form>
                    <div className="row">
                        <div className="col-md-6 form-group">
                            <Form.Item label="Correo">
                                {getFieldDecorator('correoCliente', {
                                    initialValue: this.props.formValues.correoCliente,
                                    rules: [{
                                        validator: this.correoCustomValidation,
                                        required: true,
                                        message: 'Campo obligatorio.'
                                    }]
                                })(
                                    <Input
                                        placeholder="Ingresar Correo"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-6 form-group">
                            <Form.Item label="Copia a">
                                {getFieldDecorator('copia', {
                                    initialValue: this.props.formValues.copia,
                                    rules: [{
                                        validator: this.correoCustomValidation
                                    }]
                                })(
                                    <Input
                                        placeholder="Ingresar Copia a"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>

                        
                    </div>
 
                </Form>
            </Modal>
        );
    }
}
export default Form.create()(CorreoModal)